import React, { useState, useEffect } from 'react';
import { X, Bell, ChevronRight } from 'lucide-react';

// Fechas de vigencia del anuncio (del 16 de diciembre 2025 al 15 de enero 2026)
const START_DATE = new Date('2025-12-16T00:00:00');
const END_DATE = new Date('2026-01-16T00:00:00'); // Hasta el 15 de enero inclusive

const AnnouncementModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      {/* Overlay */}
      <div 
        className="absolute inset-0 bg-black/60 backdrop-blur-sm"
        onClick={onClose}
      />
      
      {/* Modal */}
      <div className="relative bg-[#F5EBD4] rounded-xl shadow-2xl max-w-md w-full p-6 md:p-8 animate-fadeIn">
        {/* Close button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-[#4E3A21] hover:text-[#1E1E1E] transition-colors"
          aria-label="Cerrar anuncio"
        >
          <X size={24} aria-hidden="true" />
        </button>

        {/* Icon */}
        <div className="flex justify-center mb-4">
          <div className="w-16 h-16 bg-[#7A5A2E]/10 rounded-full flex items-center justify-center">
            <Bell size={32} className="text-[#7A5A2E]" />
          </div>
        </div>

        {/* Title */}
        <h2 className="font-heading text-xl md:text-2xl text-[#1E1E1E] text-center mb-4">
          ESTAMOS PREPARANDO EL LOTE 2026
        </h2>

        {/* Content */}
        <div className="space-y-4 font-body text-[#4E3A21]">
          <p className="text-center">
            Del <strong>24 de diciembre</strong> al <strong>15 de enero</strong> no realizaremos envíos.
          </p>
          <p className="text-center text-sm opacity-90">
            Ese período lo dedicamos a terminar de curar y seleccionar el Lote 2026.
          </p>
          
          <div className="bg-[#EFE1C4] rounded-lg p-4 border-l-4 border-[#7A5A2E]">
            <p className="text-sm">
              📦 El <strong>15 de enero</strong> actualizaremos el stock con la nueva producción, que hoy se encuentra en su punto justo de curación.
            </p>
          </div>

          <p className="text-center text-sm italic opacity-80">
            Gracias por acompañarnos y elegir productos de campo hechos con tiempo.
          </p>
        </div>

        {/* Close button */}
        <button
          onClick={onClose}
          className="mt-6 w-full bg-[#7A5A2E] text-white font-body py-3 rounded-lg hover:bg-[#5C4422] transition-colors"
        >
          Entendido
        </button>
      </div>
    </div>
  );
};

const AnnouncementBanner = () => {
  const [showBanner, setShowBanner] = useState(false);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const now = new Date();
    
    // Verificar si estamos dentro del rango de fechas (16 dic 2025 - 10 ene 2026)
    if (now >= START_DATE && now <= END_DATE) {
      setShowBanner(true);
      
      // Mostrar el pop-up automáticamente solo una vez por sesión
      const hasSeenPopup = sessionStorage.getItem('elpampa_announcement_seen');
      if (!hasSeenPopup) {
        // Pequeño delay para que no aparezca inmediatamente
        setTimeout(() => {
          setShowModal(true);
          sessionStorage.setItem('elpampa_announcement_seen', 'true');
        }, 1500);
      }
    }
  }, []);

  const handleMoreInfo = () => {
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  if (!showBanner) return null;

  return (
    <>
      {/* Banner superior */}
      <div className="bg-[#7A5A2E] text-white py-2 px-4">
        <div className="max-w-6xl mx-auto flex items-center justify-center gap-2 text-sm font-body">
          <Bell size={16} className="flex-shrink-0" />
          <span className="text-center">
            <span className="hidden sm:inline">Estamos preparando el Lote 2026 - </span>
            <span>No realizamos envíos del 24/12 al 15/01</span>
          </span>
          <button
            onClick={handleMoreInfo}
            className="flex items-center gap-1 font-medium underline underline-offset-2 hover:no-underline ml-2 flex-shrink-0"
          >
            MÁS INFO
            <ChevronRight size={14} />
          </button>
        </div>
      </div>

      {/* Modal */}
      <AnnouncementModal isOpen={showModal} onClose={handleCloseModal} />
    </>
  );
};

export default AnnouncementBanner;
